import React, { useEffect, useState } from "react";
import { Add } from "@mui/icons-material";
import { Grid, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tenant } from "@commr/admin/models/tenant";
import { getTenants } from "@commr/admin/services/tenantsService";
import {
  AppSyncSearchQuery,
  AppSyncSearchResult,
} from "@commr/admin/models/common/appSyncSearch";
import SearchedUserResult from "../common/search/searchResult";
import CustomSearchHeader from "../common/customSearchHeader/customSearchHeader";
import TenantsHit from "./tenantsHit";

const TenantsContainer: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [searchResult, setSearchResult] = useState<AppSyncSearchResult>();
  const [searchQuery, setSearchQuery] = useState<AppSyncSearchQuery>(
    new AppSyncSearchQuery()
  );

  useEffect(() => {
    if (searchQuery)
      getTenants(searchQuery).then((tenants: AppSyncSearchResult) => {
        setSearchResult(tenants);
      });
  }, [searchQuery]);

  const onAddClicked = () => {
    history.push("/tenants/addTenant");
  };

  return (
    <div className="tenants-container">
      <CustomSearchHeader setSearchQuery={setSearchQuery} />
      <Grid item xs={2} sx={{ paddingTop: 1, paddingBottom: 1 }}>
        <Button
          type="button"
          variant="contained"
          size="medium"
          color="primary"
          onClick={onAddClicked}
        >
          <Add />
          {t("common:add")}
        </Button>
      </Grid>
      <SearchedUserResult
        hitComponent={
          <TenantsHit
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            searchResult={searchResult}
          />
        }
      />
    </div>
  );
};

export default TenantsContainer;
